import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TextField, CircularProgress, MuiThemeProvider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as actions from 'components/TrustCenter/store/actions';
import { isBlank } from 'components/Common/Utils/StringUtils';
import { FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME } from 'components/TrustCenter/TrustCenterMuiTheme';
import { SPINNER_THEME } from 'components/TrustCenter/VisibilityConnection/ConnectionWizard/AddConnectionMUITheme';
import ClearIcon from '@material-ui/icons/Clear';
import useDebounce from 'components/TrustCenter/UI/Debounce/Debounce';

const ProviderAsyncSearch = (props) => {
    const {
        selectedAccountType,
        isProviderAccountsLoaded,
        providers,
        getProviderAccounts,
        sendSelectedProvider
    } = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    const [userInput, setUserInput] = useState('');

    const [userSearchTerm, setUserSearchTerm] = useState('');

    const debouncedSearchTerm = useDebounce(userSearchTerm, 1000);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    useEffect(() => {
        if (isProviderAccountsLoaded) {
            setOptions([...providers]);
        }
    }, [isProviderAccountsLoaded]);

    useEffect(() => {
        if (debouncedSearchTerm.length >= 3) {
            getProviderAccounts(selectedAccountType, debouncedSearchTerm);
        }
    }, [debouncedSearchTerm]);

    const handleInputChange = (event) => {
        if (event.target.value.length >= 3) {
            setOpen(true);
            setUserSearchTerm(event.target.value);
        } else {
            setUserSearchTerm('');
            setOpen(false);
        }
        setUserInput(event.target.value);
    };

    const handleSelectedOption = (selectedOption, reason) => {
        if (reason === 'select-option') {
            sendSelectedProvider(selectedOption.id);
        } else {
            sendSelectedProvider('');
        }
    };

    return (
        <MuiThemeProvider theme={FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME}>
            <Autocomplete
                id="provider-name"
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option.name === value.name}
                getOptionLabel={(option) => option.name}
                options={options}
                loading={!isProviderAccountsLoaded}
                loadingText={
                    <MuiThemeProvider theme={SPINNER_THEME}>
                        <CircularProgress />
                    </MuiThemeProvider>
                }
                clearOnBlur={false}
                disabled={isBlank(selectedAccountType)}
                noOptionsText="(No record found)"
                onChange={(event, selectedOption, reason) =>
                    handleSelectedOption(selectedOption, reason)
                }
                closeIcon={
                    <ClearIcon
                        onClick={() => {
                            setUserInput('');
                            setUserSearchTerm('');
                        }}
                        fontSize="small"
                    />
                }
                renderInput={(params) => (
                    <TextField
                        margin="normal"
                        {...params}
                        label="Provider Name *"
                        variant="filled"
                        helperText={'Enter 3 or more characters'}
                        onChange={(event) => handleInputChange(event)}
                    />
                )}
            />
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        providers: state.connection.providers,
        selectedAccountType: state.connection.selectedAccountType,
        isProviderAccountsLoaded: state.connection.isProviderAccountsLoaded
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProviderAccounts: (selectedAccountType, searchQuery) =>
            dispatch(actions.getProviderAccounts(selectedAccountType, searchQuery)),
        toggleProviderLoaded: (flag) => dispatch(actions.toggleProviderLoaded(flag))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProviderAsyncSearch));
